class InspireProductWidget {
  constructor(container) {
    this.target = container;
    this._init();
  }

  async render() {
    const inspirewidgetWidget = this.target;
    const inspirewidgetPoints = +inspirewidgetWidget.getAttribute(
      "data-inspire-points"
    );
    if (inspirewidgetWidget && inspirewidgetPoints) {
      inspirewidgetWidget.querySelector(
        "[data-inspire-widget-points]"
      ).innerHTML = `${(inspirewidgetPoints / 1).toFixed()} Pontos`;
    }
  }
  async setEvents() {
    document.addEventListener("_EV.Cart:updated", (e) => {
      if (document.querySelector(".Minicart__Totals__Item.Featured")) {
        if (
          !!EvolveCore.Cart._store.cart.items.find(
            (i) => i.properties.inspirewidget_points
          )
        ) {
          document.querySelector(
            ".Minicart__Totals__Item.Featured"
          ).style.display = "none";
        } else {
          document.querySelector(
            ".Minicart__Totals__Item.Featured"
          ).style.display = "flex";
        }
      }
    });
  }

  async _init() {
    await this.setEvents();
    this.render();
  }
}
class InspireCartWidget {
  constructor(container) {
    this.target = container;
    this._init();
  }
  async render() {
    // inspirewidgetWidget.innerHTML = `
    //   <span class="inspirewidget__header__announcement__container">
    //     Ganhe <b>1 ponto InspireWidget por real gasto*</b> em produtos
    //     <a href="/collections/produtos-com-fps">
    //       <b>Ver todos os produtos</b>
    //     </a>
    //   </span>
    // `;
  }
  async renderInspireWidgetComponents() {
    this.render();
  }
  async setEvents() {
    document.addEventListener("_EV.Cart:updated", (e) => {
      if (document.querySelector(".Minicart__Totals__Item.Featured")) {
        if (
          !!EvolveCore.Cart._store.cart.items.find(
            (i) => i.properties.inspirewidget_points
          )
        ) {
          document.querySelector(
            ".Minicart__Totals__Item.Featured"
          ).style.display = "none";
        } else {
          document.querySelector(
            ".Minicart__Totals__Item.Featured"
          ).style.display = "flex";
        }
      }
    });
  }

  async _init() {
    await this.setEvents();
    await this.renderInspireWidgetComponents();
  }
}

document.querySelectorAll("[data-inspire-widget]").forEach((element) => {
  new InspireProductWidget(element);
});

document
  .querySelectorAll("[data-inspire-header-announcement]")
  .forEach((element) => {
    new InspireCartWidget(element);
  });
